<a
  class="whatsapp-wrap"
  href="https://wa.me/5544984641888?text=Ol%C3%A1!%20Vim%20do%20site%20e%20gostaria%20de%20atendimento."
  target="_blank"
  rel="noopener noreferrer"
>
  <img
    src="assets/images/cta/whatsapp.png"
    alt="WhatsApp"
    class="whatsapp-icon"
  />
</a>
